
import Level from "../../../assets/duotone/Level.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LevelIcon({ className, dataTestid = "LevelIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Level data-testid={dataTestid} className={classes} {...rest} />
  );
}
